import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ErrorResponse } from "src/types/error-response.type";
import { mapData } from './mapActions';
import { sat } from 'src/types/request.type';

type MapState = {
  dataMap: {
    payload: sat | null,
    loading: boolean,
    success: boolean,
    error: string | null;
  }
}

const initialState: MapState = {
  dataMap: {
    loading: false,
    success: false,
    payload: {
        coord: "",
        resolve: "",
        visible: "",
    },
    error: "",
  }
}




const mapSlice = createSlice({
  name: 'map',
  initialState: initialState,
  reducers: {
    // Обычные редьюсеры
    setMapState(state, action: PayloadAction<sat>) {
      state.dataMap.payload = null;
      state.dataMap.payload = action.payload;
    },

  },


 /* extraReducers: (builder) => {
    builder
      .addCase(mapData.pending, (state) => {
        state.dataMap.loading = true;
        state.dataMap.error = null;
      })
      .addCase(mapData.fulfilled, (state, action) => {
        state.dataMap.loading = false;
        mapSlice.caseReducers.setMapState(state, action);
      })
      .addCase(mapData.rejected, (state, action) => {
        state.dataMap.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataMap.error = errorText ? errorText : "";
      })

  }*/

})


const getErrorText = (error: ErrorResponse) => {

 // console.log(error);

  switch (error?.error) {
    case "invalid0":
      return "invalid0";
    case "invalid1":
      return "invalid1";
    default:
      return "";
  }
}


export const mapSliceNavi = mapSlice.reducer;

